import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { tokens } from "../../theme";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useTheme,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./profile.css";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import AudioPlayer from "../../components/AudioPlayer";
import { API_BASE } from "../../api";

const S3_BASE = "https://matrize.s3.ap-south-1.amazonaws.com";

const SurveyDetail = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID", width: 72, align: "center", headerAlign: "center" },
    { field: "question", headerName: "Question", flex: 1, minWidth: 260 },
    { field: "answer", headerName: "Answer", flex: 1, minWidth: 280 },
  ];

  const [userData, setUserData] = useState([]);
  const [quesans, setQuesans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [consentImageOk, setConsentImageOk] = useState(true);
  const [profilePhotoError, setProfilePhotoError] = useState(false);
  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const personalInfoCardRef = useRef(null);
  const [signaturePanelHeightPx, setSignaturePanelHeightPx] = useState(null);

  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/surveys/${id}?role=${props.role}`).then(response => {
      return response.json()
    }).then((data) => {
      setUserData(data.resultobj);
      setConsentImageOk(true);
      setProfilePhotoError(false);
      setLoading(false);
    });

    fetch(`${API_BASE}/surveyReport/${id}`).then(response => {
      return response.json()
    }).then(data => {
      setQuesans(convertDataToFormattedArray(data?.data[0]));
    })
  }, [])

  useLayoutEffect(() => {
    if (loading) return undefined;
    const el = personalInfoCardRef.current;
    if (!el) return undefined;
    const sync = () => {
      const h = el.getBoundingClientRect().height;
      if (h > 0) setSignaturePanelHeightPx(Math.round(h));
    };
    sync();
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(sync) : null;
    ro?.observe(el);
    window.addEventListener("resize", sync);
    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, [loading, userData, quesans]);

  function convertDataToFormattedArray(data) {
    const formattedArray = [];
    let id = 1;

    let keys = Object.keys(data);
    let values = Object.values(data);
    for (let i =0; i < keys.length; i++) {
        const question = keys[i];
        const answer = values[i];

        formattedArray.push({
            id:i,
            question,
            answer
        });
    }
    return formattedArray;
}
function rotateImageClockWise() {
  const el = document.getElementById("profile_img");
  if (el) el.style.transform = "rotate(90deg)";
}

  const consentSrc =
    userData?.phone != null &&
    userData.phone !== "" &&
    userData?.campaignId != null &&
    String(userData.campaignId).trim() !== ""
      ? `${S3_BASE}/matrize/userconsent/${userData.phone}_${userData.campaignId}.png`
      : null;

  return (
    <>
      <Box m="20px">
        <button
          type="button"
          style={{
            padding: "0px 11px",
            borderRadius: "10px",
            backgroundColor: "#7e1d1d",
            border: "none",
            cursor: "pointer",
            color: "#fff",
          }}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowBackIcon />
        </button>
      </Box>
      <div className="survey-detail-shell">
      <div className="profileContent">
        {loading && (
          <div className="survey-detail-top-loading">Loading survey details…</div>
        )}
        {!loading && (
        <>
        <div className="sidenav">
          <div className="profile">
          <div
            className={
              profilePhotoError || !userData?.phone
                ? "profile__media profile__media--no-photo"
                : "profile__media"
            }
          >
            {(profilePhotoError || !userData?.phone) && (
              <span className="profile__no-img-label">No respondent photo</span>
            )}
            {userData?.phone && (
              <img
                src={`${S3_BASE}/matrize/images/${userData.phone}i.jpg`}
                id="profile_img"
                className={
                  profilePhotoError
                    ? "profile__photo-img profile__photo-img--hidden"
                    : "profile__photo-img"
                }
                alt=""
                onError={() => setProfilePhotoError(true)}
              />
            )}
            {!profilePhotoError && userData?.phone && (
            <button
              type="button"
              className="profile__rotate-btn"
              onClick={rotateImageClockWise}
            >
              Rotate Image
            </button>
            )}
          </div>
          </div>
          <AudioPlayer
            audioUrl={`${S3_BASE}/matrize/audio/${userData?.phone}a.mp3`}
          />
        </div>
        <div className="survey-detail-info-row">
        <div
          className="consent-signature"
          aria-label="User consent signature"
          style={
            signaturePanelHeightPx != null
              ? { height: signaturePanelHeightPx, minHeight: signaturePanelHeightPx }
              : undefined
          }
        >
          <div className="consent-signature__head">
            <div className="consent-signature__title">Consent signature</div>
            {consentSrc && consentImageOk && (
              <button
                type="button"
                className="consent-signature__expand-btn"
                onClick={() => setSignatureDialogOpen(true)}
              >
                Expand
              </button>
            )}
          </div>
          {consentSrc ? (
            consentImageOk ? (
              <div className="consent-signature__viewport">
                <img
                  className="consent-signature__img"
                  src={consentSrc}
                  alt="Respondent consent signature"
                  onError={() => setConsentImageOk(false)}
                />
              </div>
            ) : (
              <p className="consent-signature__empty consent-signature__empty--grow">
                No consent signature file found for this survey (or image failed
                to load).
              </p>
            )
          ) : (
            <p className="consent-signature__empty consent-signature__empty--grow">
              Campaign not linked to this record — consent image path unknown.
            </p>
          )}
        </div>
        <div className="main survey-detail-main">
          <div className="card" ref={personalInfoCardRef}>
            <div className="card-body survey-detail-card-body">
              <i className="fa fa-pen fa-xs edit" aria-hidden="true" />
              <table className="survey-detail-info-table">
                <tbody>
                  <tr>
                    <td className="profile_heading">Name</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.name}>{userData['name']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Phone</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={String(userData?.phone)}>{userData['phone']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Age</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={String(userData?.age)}>{userData['age']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Gender</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.gender}>{userData['gender']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Education</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.education}>{userData['education']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Business</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.business}>{userData['business']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Income</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.income}>{userData['income']}</td>
                  </tr>
                  <tr>
                    <td className="profile_heading">Caste</td>
                    <td className="profile_colon">:</td>
                    <td className="profile_data" title={userData?.caste}>{userData['caste']}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* <h2>SOCIAL MEDIA</h2>
          <div className="card">
            <div className="card-body">
              <i className="fa fa-pen fa-xs edit"></i>
              <div className="social-media">
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-facebook fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-twitter fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-instagram fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-invision fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-github fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-whatsapp fa-stack-1x fa-inverse"></i>
                </span>
                <span className="fa-stack fa-sm">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-snapchat fa-stack-1x fa-inverse"></i>
                </span>
              </div>
            </div>
          </div> */}
          {/* <DataGrid checkboxSelection rows={} columns={columns} />)  */}
        </div>
        </div>
        </>
        )}
      </div>
      <Box
        className="survey-detail-datagrid-wrap"
        sx={{
          height: 440,
          width: "100%",
          maxWidth: "100%",
          mt: 3,
          mb: 4,
          "& .MuiDataGrid-root": { border: "none", minWidth: 0 },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #e8f0f8",
            color: colors.grey[100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#002b5c",
            borderBottom: "none",
            color: "#ffffff",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 600,
            color: "#ffffff",
            textAlign: "center",
            width: "100%",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            justifyContent: "center",
            width: "100%",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: "#f5f8fc",
          },
        }}
      >
        <DataGrid rows={quesans} columns={columns} />
      </Box>
      </div>

      <Dialog
        fullScreen
        open={signatureDialogOpen}
        onClose={() => setSignatureDialogOpen(false)}
        scroll="paper"
        PaperProps={{
          sx: {
            m: 0,
            maxHeight: "100%",
            display: "flex",
            flexDirection: "column",
            bgcolor: "#f5f8fc",
          },
        }}
        aria-labelledby="signature-dialog-title"
      >
        <DialogTitle
          id="signature-dialog-title"
          sx={{
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            borderBottom: "1px solid #dce8f4",
            bgcolor: "#fff",
            color: "#002b5c",
          }}
        >
          Consent signature
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setSignatureDialogOpen(false)}
            aria-label="Close full screen signature"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "auto",
            bgcolor: "#f5f8fc",
            p: { xs: 1, sm: 2 },
          }}
        >
          {consentSrc && (
            <Box
              component="img"
              src={consentSrc}
              alt="Respondent consent signature — full size"
              sx={{
                display: "block",
                width: "auto",
                height: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </DialogContent>
        <DialogActions
          sx={{
            flexShrink: 0,
            px: 2,
            py: 1.5,
            borderTop: "1px solid #dce8f4",
            bgcolor: "#fff",
          }}
        >
          <Button onClick={() => setSignatureDialogOpen(false)} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SurveyDetail;
